import { render, staticRenderFns } from "./TariffPrem.vue?vue&type=template&id=6480d231&"
import script from "./TariffPrem.vue?vue&type=script&lang=js&"
export * from "./TariffPrem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports